var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6725_7116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71 10.38L2.83 6.50003L6.71 2.62003C7.1 2.23003 7.1 1.60003 6.71 1.21003C6.32 0.820028 5.69 0.820028 5.3 1.21003L0.710003 5.80003C0.320003 6.19003 0.320003 6.82003 0.710003 7.21003L5.3 11.8C5.69 12.19 6.32 12.19 6.71 11.8C7.09 11.41 7.1 10.77 6.71 10.38Z",
    fill: "#5F6CE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6725_7116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    rx: 4,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 8 12.5)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlue);
export default __webpack_public_path__ + "static/media/leftArrowBlue.08aa7c10a2f973c306e8b796d4c92a36.svg";
export { ForwardRef as ReactComponent };